{
  "en": {
    "global": {
      "for": "for",
      "en": "English",
      "fr": "French"
    },
    "menu": {
      "home": "Home",
      "customers": "Customers",
      "users": "Users",
      "distributors": "Distributors",
      "jobs": "Jobs",
      "server": "Server",
      "configurations": "Configurations",
      "logOff": "Disconnect"
    },

    "tab": {
      "applicationAccess": "Application Access",
      "fieldsCustomization": "Fields customization",
      "translations": "Translations",
      "applicationDomain": "Application Domains",
      "mailAlert": "Mails & Alerts",
      "scheduler": "Scheduler",
      "activity": "Activity monitoring",
      "logBatches": "Logs",
      "logAppointment": "Appointments/Logs"
    },

    "widget": {
      "allCustomers": "Customers",
      "sfaCustomers": "SFA customers",
      "nbUsers": "Users count",
      "nbUsersSales": "Sales users count",
      "nbUsersMaterial": "Material users count",
      "nbUsersEvent": "Event users count",
      "nbUsersMerch": "Merch users count",
      "nbUsersRent": "Rent users count",
      "nbUsersDoc": "Doc users count",
      "nbUsersSfa": "SFA users count",
      "nbUsersAssort": "Assort users count",
      "nbUsersSimulation": "Simulation users count"
    },

    "action": {
      "add": "add",
      "save": "save",
      "undoAll": "undo all",
      "cancel": "cancel",
      "ok": "valid",
      "logs": "logs",
      "download": "Download",
      "downloadAll": "Download all",
      "copyAll": "Copy all",
      "copiedInClipboard": "Copied to clipboard !",
      "logIn": "Sign in",
      "launch": "launch",
      "history": "History",
      "serverFiles": "Server",
      "serverConfigFiles": "Configurations",
      "defaultConfigsFiles": "Default configs files",
      "upload": "Upload",
      "delete": "Delete",
      "close": "Close",

      "newCustomer": "new customer",
      "newUser": "new user",
      "newDistributor": "new distributor",
      "newConfiguration": "new configuration",
      "refreshUser": "refresh user",
      "manualExecution": "Execution"
    },

    "subTitle": {
      "processList": "Process list",
      "runningProcessList": "Running process"
    },

    "field": {
      "name": "Name",
      "reference": "Reference",
      "alias": "Alias",
      "database": "Database",
      "country": "Country",
      "ediEnabled": "EDI active",
      "active": "Active",
      "customer": "Customer",
      "entity": "Entity",
      "applicationDomain": "Domain",
      "type": "Type",
      "contextType": "Context",
      "requiredForPublishing": "Required for publishing",
      "ediOnly": "EDI only",
      "label": "Label",
      "customerName": "Customer name",
      "language": "Language",
      "password": "Password",
      "startDate": "Start date",
      "endDate": "End date",
      "group": "Group",
      "mode": "Mode",
      "action": "Action",
      "application": "Application",
      "provider": "Provider",
      "job": "Job",
      "demo": "Demo",
      "picture": "Logo",
      "maxUsers": "Max users",
      "phone": "Phone",
      "comment": "Comment",
      "address": "Address",
      "email": "Email",
      "distributor": "Distributor",
      "firstName": "First name",
      "lastName": "Last name",
      "userName": "User name",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmNewPassword": "Confirm new password",
      "favoritePaths": "Favorite paths",
      "accessLevel": "Access level",
      "none": "None"
    },

    "dialog": {
      "newAttribute": "Add an attribute",
      "deleteAttribute": "Attribute deletion",
      "sureToDeleteAttribute": "Are you sure to delete this attribute ?",
      "newApplicationDomain": "Add an application domain",
      "logs": "Logs",
      "files": "Files",
      "manualExecution": "Execution",
      "manualExecutionHistory": "Execution history",
      "serverFiles": "Server",
      "serverConfigFiles": "Configurations",
      "customerDistributorLinks": "Distributor/customer links",
      "sureToDeleteDistributor": "Are you sure to delete the distributor",
      "deleteDistributor": "Distributor deletion"
    },

    "echarts": {
      "disabled": "Disabled",
      "manyDisabled": "Partially disabled",
      "enabled": "Enabled"
    },

    "column": {
      "name": "Name",
      "type": "Type",
      "reference": "Reference",
      "alias": "Alias",
      "value": "Value",
      "requiredForPublishing": "Required for publishing",
      "ediOnly": "EDI only",
      "locales": "Languages",
      "applicationDomain": "Application domain",
      "menu": "Menu",
      "description": "Description",
      "startDate": "Start date",
      "delay": "Delay",
      "shortMsg": "Message",
      "roles": "Roles",
      "mode": "Mode",
      "active": "Active",
      "firstName": "First name",
      "lastName": "Last name",
      "userName": "User name",
      "infos": "Informations",
      "apps": "Applications",
      "hours": "Hour",
      "customer": "Customer",
      "batFile": "BAT file",
      "action": "Action",
      "file": "File",
      "exportFile": "Export file",
      "parameters": "Parameters",
      "createdDate": "Created date",
      "modifiedDate": "Modified date",
      "size": "Size",
      "user": "User",
      "actionGroup": "Action",
      "state": "State",
      "demo": "Demo",
      "ediEnabled": "EDI active",
      "lastLogonDate": "Last logon date",
      "country": "Country",
      "maxUsers": "Max users",
      "totalUsers": "Total users",
      "distributor": "Distributor",
      "email": "Email",
      "isCustom": "Custom",
      "favorite": "Bookmark",
      "accessLevel": "Access level",
      "restart": "Restart",
      "count": "Count"
    },

    "toast": {
      "moreUserLoading": "Loading users.",
      "moreAppLoading": "Loading applications access.",
      "tasksUpdated": "No task was updated. | One task was updated. | {count} tasks updated.",
      "userInfoWellSaved": "User informations saved.",
      "customerInfoWellSaved": "Customer saved.",
      "customerParamsWellSaved": "Customer parameters saved.",
      "attributeAlreadyTaken": "Attribute name already taken.",
      "mailAlreadyTaken": "Mail already taken.",
      "pspNotWorkingInDev": "PSP is currently not working on DEV.",
      "refreshCustomerAfterUpdate": "Refreshing customer users due to an update.",
      "loginPasswordMismatch": "Login and password mismatch.",
      "noFilesFound": "No files found.",
      "fileTooBig": "File is too big! (> 5Mo)",
      "filesUploadedSucess": "Files uploaded successfully.",
      "distributorInfoWellSaved": "Distributor saved.",
      "folderNeedToBeOpened": "Destination folder should be opened.",
      "warningSFAImportDeliveryLocationSegmentFull": "Les magasins non présents dans le fichier verront leurs strates supprimées.",
      "all": "All",
      "loadingAllBatchesAllCustomers": "Loading all batches, from all customers, from last day only.",
      "required": "Required",
      "max50char": "Maximum 50 caractères",
      "numOnly" : "Numbers only"
    },

    "tooltip": {
      "updateInProgress": "Update in progress",
      "lastUpdate": "Last update :"
    },

    "varType": {
      "none": "None",
      "string": "Text",
      "int": "Integer",
      "boolean": "Boolean",
      "openlist": "Single list",
      "openlistmultiple": "Multiple list",
      "datetime": "Date",
      "money": "Money",
      "decimal": "Decimal"
    },

    "contextType": {
      "global": "Global",
      "account": "Account",
      "accountperiod": "Account/period",
      "channel": "Channel",
      "channelperiod": "Channel/period"
    }
  },
  "fr": {
    "global": {
      "for": "pour",
      "en": "Anglais",
      "fr": "Français"
    },
    "menu": {
      "home": "Accueil",
      "customers": "Clients",
      "users": "Utilisateurs",
      "distributors": "Distributeurs",
      "jobs": "Jobs",
      "server": "Serveur",
      "configurations": "Configurations",
      "logOff": "Se déconnecter"
    },

    "tab": {
      "applicationAccess": "Paramétrage des applications",
      "fieldsCustomization": "Attributs",
      "translations": "Traductions",
      "applicationDomain": "Moyens",
      "mailAlert": "Mails & Alertes",
      "scheduler": "Planifications",
      "activity": "Monitoring d'activité",
      "logBatches": "Logs",
      "logAppointment": "Appointments/Logs"
    },

    "widget": {
      "allCustomers": "Clients",
      "sfaCustomers": "Clients SFA",
      "nbUsers": "Nombre d'utlisateurs",
      "nbUsersSales": "Nombre d'utlisateurs Sales",
      "nbUsersMaterial": "Nombre d'utlisateurs Material",
      "nbUsersEvent": "Nombre d'utlisateurs Event",
      "nbUsersMerch": "Nombre d'utlisateurs Merch",
      "nbUsersRent": "Nombre d'utlisateurs Rent",
      "nbUsersDoc": "Nombre d'utlisateurs Doc",
      "nbUsersSfa": "Nombre d'utlisateurs SFA",
      "nbUsersAssort": "Nombre d'utlisateurs Assort",
      "nbUsersSimulation": "Nombre d'utlisateurs Simulation"
    },

    "action": {
      "add": "ajouter",
      "save": "sauvegarder",
      "undoAll": "annuler tout",
      "cancel": "annuler",
      "ok": "valider",
      "logs": "logs",
      "download": "Télécharger",
      "downloadAll": "Tout télécharger",
      "copyAll": "Copier",
      "copiedInClipboard": "Copié dans le presse papier !",
      "logIn": "Se connecter",
      "launch": "Lancer",
      "history": "Historique",
      "serverFiles": "Serveur",
      "serverConfigFiles": "Configurations",
      "defaultConfigsFiles": "Fichiers de configuration par défaut",
      "upload": "Upload",
      "delete": "Supprimer",
      "close": "Fermer",

      "newCustomer": "nouveau client",
      "newUser": "nouvel utilisateur",
      "newDistributor": "nouveau distributeur",
      "newConfiguration": "nouvelle configuration",
      "refreshUser": "rafraichir les utilisateurs",
      "manualExecution": "Exécution"
    },

    "subTitle": {
      "processList": "Liste des process",
      "runningProcessList": "Process en cours"
    },

    "field": {
      "name": "Nom",
      "reference": "Référence",
      "alias": "Alias",
      "database": "Base de donnée",
      "country": "Pays",
      "ediEnabled": "EDI actif",
      "active": "Actif",
      "customer": "Client",
      "entity": "Entité",
      "applicationDomain": "Moyens",
      "type": "Type",
      "contextType": "Contexte",
      "requiredForPublishing": "Requis pour la publication",
      "ediOnly": "Seulement pour les EDI",
      "label": "Libellé",
      "customerName": "Code moyen",
      "language": "Langue",
      "password": "Mot de passe",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "group": "Groupe",
      "mode": "Mode",
      "action": "Action",
      "application": "Application",
      "provider": "Fournisseur",
      "job": "Job",
      "demo": "Démo",
      "picture": "Logo",
      "maxUsers": "Max utilisateurs",
      "phone": "Téléphone",
      "comment": "Commentaire",
      "address": "Adresse",
      "email": "Email",
      "distributor": "Distributeur",
      "firstName": "Prénom",
      "lastName": "Nom",
      "userName": "Nom d'utilisateur",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmNewPassword": "Confirmation du nouveau mot de passe",
      "favoritePaths": "Chemins favoris",
      "accessLevel": "Niveau d'accès",
      "none": "Aucun"
    },

    "dialog": {
      "newAttribute": "Ajouter un attribut",
      "deleteAttribute": "Suppression d'attribut",
      "sureToDeleteAttribute": "Êtes-vous sûr de supprimer cet attribut ?",
      "newApplicationDomain": "Ajouter un moyen",
      "logs": "Logs",
      "files": "Fichiers",
      "manualExecution": "Exécution",
      "manualExecutionHistory": "Historique d'exécution",
      "serverFiles": "Serveur",
      "serverConfigFiles": "Configurations",
      "customerDistributorLinks": "Liens distributeur/client",
      "sureToDeleteDistributor": "Êtes-vous sûr de supprimer le distributeur",
      "deleteDistributor": "Suppression d'un distributeur"
    },

    "echarts": {
      "disabled": "Complètement désactivé",
      "manyDisabled": "Partiellement désactivé",
      "enabled": "Activé"
    },

    "column": {
      "name": "Nom",
      "type": "Type",
      "reference": "Référence",
      "alias": "Alias",
      "value": "Valeur",
      "requiredForPublishing": "Requis pour la publication",
      "ediOnly": "Seulement pour les EDI",
      "locales": "Langues",
      "applicationDomain": "Moyens",
      "menu": "Menu",
      "description": "Description",
      "startDate": "Date de début",
      "delay": "Délai",
      "shortMsg": "Message",
      "roles": "Roles",
      "mode": "Mode",
      "active": "Actif",
      "firstName": "Prénom",
      "lastName": "Nom",
      "userName": "User name",
      "infos": "Informations",
      "apps": "Applications",
      "hours": "Heure",
      "customer": "Client",
      "batFile": "Fichier BAT",
      "action": "Action",
      "file": "Fichier",
      "exportFile": "Fichier d'export",
      "parameters": "Paramètres",
      "createdDate": "Date de création",
      "modifiedDate": "Date de modification",
      "size": "Taille",
      "user": "Utilisateur",
      "actionGroup": "Action",
      "state": "État",
      "demo": "Démo",
      "ediEnabled": "EDI actifs",
      "lastLogonDate": "Dernière connexion",
      "country": "Pays",
      "maxUsers": "Max utilisateurs",
      "totalUsers": "Total utilisateurs",
      "distributor": "Distributeur",
      "email": "Email",
      "isCustom": "Personnalisée",
      "favorite": "Favoris",
      "accessLevel": "Niveau d'accès",
      "restart": "Relancer",
      "count": "Nombre"
    },

    "toast": {
      "moreUserLoading": "Chargement des utilisateurs.",
      "moreAppLoading": "Chargement des applications.",
      "tasksUpdated": "Aucune tâche n'a été mise à jour. | Une tâche a été mise à jour. | {count} tâches ont été mise à jour.",
      "userInfoWellSaved": "Infos utilisateurs sauvegardées.",
      "customerInfoWellSaved": "Infos client sauvegardées.",
      "customerParamsWellSaved": "Paramètres client sauvegardés.",
      "attributeAlreadyTaken": "Ce nom d'attribut existe déjà.",
      "mailAlreadyTaken": "Cette adresse e-mail est déjà utilisée.",
      "pspNotWorkingInDev": "L'accès au PSP est désactivé en DEV.",
      "refreshCustomerAfterUpdate": "Rafraichissement des utilisateurs.",
      "loginPasswordMismatch": "Le login et le mot de passe ne correspondent pas.",
      "noFilesFound": "Aucun fichier n'a été trouvé.",
      "fileTooBig": "Le fichier est trop volumineux (> 5Mo)",
      "filesUploadedSucess": "Les fichiers ont été uploadé avec succès.",
      "distributorInfoWellSaved": "Infos distributeur sauvegardées.",
      "folderNeedToBeOpened": "Le dossier de destination doit être ouvert.",
      "warningSFAImportDeliveryLocationSegmentFull": "Les magasins non présents dans le fichier verront leurs strates supprimées.",
      "all": "Tous",
      "loadingAllBatchesAllCustomers": "Chargement de tous les batches, de tous les clients, du dernier jour uniquement.",
      "required": "Obligatoire",
      "max50char": "Max 50 characters",
      "numOnly" :"Chiffres uniquement"
    },

    "tooltip": {
      "updateInProgress": "Mise à jour en cours",
      "lastUpdate": "Dernière mise à jour :"
    },

    "varType": {
      "none": "Aucun",
      "string": "Texte",
      "int": "Nombre entier",
      "boolean": "Booléen",
      "openlist": "Liste à choix unique",
      "openlistmultiple": "Liste à choix multiple",
      "datetime": "Date",
      "money": "Monétaire",
      "decimal": "Nombre décimal"
    },

    "contextType": {
      "global": "Global",
      "account": "Enseigne",
      "accountperiod": "Enseigne/période",
      "channel": "Circuit",
      "channelperiod": "Circuit/période"
    }
  }
}